import { InferType } from 'yup'

import { ClaimFreeDiscountSchemaType } from 'directFlow/pages/ClaimFreeDiscount/schema'
import { getAdditionalDriverSchema } from 'directFlow/pages/Drivers/schema/additionalDriverSchema'
import { DriversSchemaType } from 'directFlow/pages/Drivers/schema/schema'
import { claimsModalSchema } from 'directFlow/pages/History/components/ClaimsField/AddClaimModalForm'
import { convictionsModalSchema } from 'directFlow/pages/History/components/ConvictionsField/AddConvictionForm'
import { HistorySchemaType } from 'directFlow/pages/History/schema'
import { LicenceSchemaType } from 'directFlow/pages/Licence/schema/schema'
import { ManualVehicleLookupSchemaType } from 'directFlow/pages/ManualVehicleLookup/schema'
import { PolicyStartDateSchemaType } from 'directFlow/pages/PolicyStartDate/schema/schema'
import { PreviousCancellationSchemaType } from 'directFlow/pages/PreviousCancellation/schema'
import { PreviousCancellationYearSchemaType } from 'directFlow/pages/PreviousCancellationYear/schema'
import { RegistrationSchemaType } from 'directFlow/pages/Registration/schema'
import { UsageSchemaType } from 'directFlow/pages/Usage/schema/schema'
import { modificationModalSchema } from 'directFlow/pages/Vehicle/components/VehicleModificationsField/AddModificationForm'
import { VehicleSchemaType } from 'directFlow/pages/Vehicle/schema'
import { VehicleFoundSchemaType } from 'directFlow/pages/VehicleFound/schema/schema'
import { Page, StepPage } from 'directFlow/types'

export type AdditionalDriverItem = InferType<ReturnType<typeof getAdditionalDriverSchema>>

export enum SettlementType {
  AT_FAULT = 'AT_FAULT',
  NOT_AT_FAULT = 'NOT_AT_FAULT',
  OUTSTANDING = 'OUTSTANDING',
}

export type ClaimItem = InferType<typeof claimsModalSchema>

export type ConvictionItem = InferType<typeof convictionsModalSchema>

export enum SignageType {
  NONE = 'NONE',
  FRONT = 'FRONT',
  BACK = 'BACK',
  SIDES = 'SIDES',
  FRONT_AND_BACK = 'FRONT_AND_BACK',
  FRONT_AND_SIDES = 'FRONT_AND_SIDES',
  BACK_AND_SIDES = 'BACK_AND_SIDES',
  FRONT_BACK_AND_SIDES = 'FRONT_BACK_AND_SIDES',
}

export type ModificationItem = InferType<typeof modificationModalSchema>

export type State = {
  [Page.REGISTRATION]: RegistrationSchemaType
  [Page.MVL]: ManualVehicleLookupSchemaType
  [Page.VEHICLE_FOUND]: VehicleFoundSchemaType
  [Page.VEHICLE]: VehicleSchemaType
  [Page.LICENCE]: LicenceSchemaType
  [Page.HISTORY]: HistorySchemaType
  [Page.CLAIM_FREE_DISCOUNT]: ClaimFreeDiscountSchemaType
  [Page.DRIVERS]: DriversSchemaType
  [Page.PREVIOUS_CANCELLATION]: PreviousCancellationSchemaType
  [Page.PREVIOUS_CANCELLATION_YEAR]: PreviousCancellationYearSchemaType
  [Page.USAGE]: UsageSchemaType
  [Page.POLICY_START_DATE]: PolicyStartDateSchemaType
}

export type FormValues<CurrentPage extends StepPage> = State[CurrentPage]
